export * from './entity-audit-event.model';
export * from './entity-audit-event.service';
export * from './entity-audit-event-detail.component';
export * from './entity-audit-event.component';
export * from './entity-audit-event.route';



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/entity-audit-event/index.ts